import { type RouteRecordRaw } from "vue-router";

import { APP_SCHEDULE_ROUTES as SCHEDULE } from "@/Generated/Routes/paths";
import { buildBeforeEnterChain, fetchAppointmentGuard, fetchAppointmentsGuard, initWSGuard } from "../guards";

export default [
  {
    path: SCHEDULE.root.path,
    component: () => import("@/Components/layout/MainLayout.vue"),
    beforeEnter: buildBeforeEnterChain(initWSGuard),
    children: [
      {
        path: SCHEDULE.root.path,
        components: {
          sidebar: () => import("@/Components/layout/SidebarLayout.vue"),
          main: () => import("@/Views/schedule/index.vue"),
        },
        meta: {
          sidebar: true,
          drawer: false,
        },
        beforeEnter: buildBeforeEnterChain(fetchAppointmentsGuard),
        children: [
          {
            ...SCHEDULE.root,
            component: () => import("@/Views/schedule/views/ListSidebar.vue"),
            meta: {
              noHeader: true,
            },
          },
          {
            ...SCHEDULE.register.root,
            component: () => import("@/Views/schedule/views/RegisterAppointment.vue"),
            meta: {
              noHeader: true,
            },
          },
          {
            ...SCHEDULE.register.couple.root,
            component: () => import("@/Views/schedule/views/SelectCouple.vue"),
            meta: {
              noHeader: true,
            },
          },
          {
            ...SCHEDULE.view.root,
            component: () => import("@/Views/schedule/views/AppointmentDetail.vue"),
            meta: {
              noHeader: true,
            },
            beforeEnter: buildBeforeEnterChain(fetchAppointmentGuard),
          },
          {
            ...SCHEDULE.edit.root,
            component: () => import("@/Views/schedule/views/RegisterAppointment.vue"),
            meta: {
              noHeader: true,
            },
            beforeEnter: buildBeforeEnterChain(fetchAppointmentGuard),
          },
          {
            ...SCHEDULE.edit.couple.root,
            component: () => import("@/Views/schedule/views/SelectCouple.vue"),
            meta: {
              noHeader: true,
            },
          },
        ],
      },
    ],
  },
] as RouteRecordRaw[];
